export const firebaseConfig = {
    apiKey: "AIzaSyAsXHFsjTSEZXOVF_718pYNLZcSaoNkCnM",
    authDomain: "ecommerce-745f5.firebaseapp.com",
    projectId: "ecommerce-745f5",
    storageBucket: "ecommerce-745f5.appspot.com",
    messagingSenderId: "242275219087",
    appId: "1:242275219087:web:41173144e15817af8922fa"
  };